<div class="datasources-container"
     joyrideStep="nineth"
     title="View File Details"
     text="In this section, you can view the detailed information related to your uploaded file. This includes metadata and any extracted content."
     (done)="onJoyrideTourDone()">
  <!-- DATASOURCES -->
  <rappider-ai-crud-view #aiCrudViewComponent
                         [activeEntityConfig]="entityConfig"
                         [entityConfigs]="entityConfigs"
                         [displayGripButton]="false"
                         [defaultEntityNameIfNotSelected]="'DataSource'"
                         [entityData]="entityData"
                         [addListGridItemDefaultActions]="false"
                         [joyride]="joyride"
                         [customTemplate]="customTemplate"
                         [detailViewTitleBarActionButtons]="detailViewTitleBarActionButtons"
                         [listViewTitleBarActionButtons]="listViewTitleBarActionButtons"
                         (entitySelected)="onEntitySelected($event)"
                         (cardCcsRenderCompleted)="onCardCcsRenderCompleted($event)"
                         (titleToolbarButtonClicked)="onTitleToolbarButtonClicked($event)"
                         (titleToolbarButtonConfirm)="onTitleToolbarButtonConfirm($event)"
                         (doneClick)="onJoyrideDoneButtonClick()"
                         (toolbarBackButtonClicked)="onToolbarBackButtonClicked($event)"
                         (entityItemSelected)="onEntityItemSelected($event)"></rappider-ai-crud-view>
</div>


<!-- RELATIONAL ENTITY FOR THE DATASOURCE -->
<ng-container *ngIf="projectModelsOfDatasource?.length && viewMode !== 'list' && viewMode !== 'edit'">
  <nz-tabset nzType="card"
             nzAnimated="true"
             nzTabPosition="top">
    <nz-tab *ngFor="let projectModel of projectModelsOfDatasource; let i = index"
            [nzTitle]="projectModel.title">
      <rappider-project-model-entity [projectModelId]="projectModel?.id"></rappider-project-model-entity>
    </nz-tab>
  </nz-tabset>
</ng-container>

<ng-template #customTemplate>
  <section class="close-button-section" [class.hidden]="!addFileTemplateVisibility">
    <div class="close-button-wrapper">
      <rappider-button class="close-button"
                       [icon]="closeButtonIcon"
                       [size]="closeButtonIcon.size"
                       [customColorSettings]="closeButtonIcon.customColorSettings"
                       [borderSettings]="closeButtonIcon.borderSettings"
                       (click)="onCardSelectorModalVisibility(false)"></rappider-button>
    </div>
    <rappider-datasource-add-with-file [dataSourceId]="currentDataSourceId" (successfullySubmitted)="onSuccessfullySubmitted($event)"></rappider-datasource-add-with-file>
  </section>
</ng-template>
